/**
 * Thin wrapper around `window.location.assign` so tests can spy without
 * fighting jsdom's non-configurable Location.assign. Also the natural
 * seam if we ever need to pre-process the URL (e.g. append analytics
 * params) before navigating.
 */

export function redirectToTmm(url: string): void {
	window.location.assign(url);
}
